import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import blueBg from "../../../Media/SVG/card_account_blue.svg";
import yellowBg from "../../../Media/SVG/card_account_yellow.svg";
import greenBg from "../../../Media/SVG/card_account_green.svg";
import redBg from "../../../Media/SVG/card_account_red.svg";
import { isoToJalali } from "../../../helper/isoToJalali";
import { useEffect, useState } from "react";

export default function Container({
  color,
  account,
  user,
  accountType,
  setIsLoading,
}) {
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [bgLoaded, setBgLoaded] = useState(false);

  const bgMap = {
    blue: blueBg,
    yellow: yellowBg,
    green: greenBg,
    red: redBg,
  };
  const bg = bgMap[color];

  // 🔹 preload background image
  useEffect(() => {
    setBgLoaded(false);

    const img = new Image();
    img.src = bg;

    img.onload = () => setBgLoaded(true);
    img.onerror = () => setBgLoaded(true);
  }, [bg]);

  // 🔹 notify parent when ALL images are loaded
  useEffect(() => {
    if (logoLoaded && bgLoaded) {
      setIsLoading(false);
    }
  }, [logoLoaded, bgLoaded, setIsLoading]);

  const textColorMap = {
    blue: "#9DEEFF",
    yellow: "#FFFF9D",
    green: "#A2FF9D",
    red: "#FF9D9D",
  };
  const textColor = textColorMap[color];

  return (
    <div
      className="overflow-hidden w-full p-5 pl-7 flex flex-col justify-between transition-opacity duration-300"
      style={{
        opacity: logoLoaded && bgLoaded ? 1 : 0,
        backgroundImage: `url(${bg})`,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        aspectRatio: "388 / 246",
      }}
    >
      <div className="w-full flex flex-col">
        <div className="w-full flex justify-between items-center mb-2.5">
          <span className="text-zi-text-dark" style={{ color: textColor }}>
            {user && user.fn && user.ln
              ? `${user.fn} ${user.ln}`
              : localStorage.getItem("email")}
          </span>

          <img
            src={LogoWhite10}
            className="w-7"
            onLoad={() => setLogoLoaded(true)}
            onError={() => setLogoLoaded(true)}
            alt="لوگو"
          />
        </div>

        <span className="text-xl font-medium text-zi-text-dark mb-4">
          {account
            ? account.phase_type === "phase1"
              ? "فاز اول"
              : account.phase_type === "phase2"
              ? "فاز دوم"
              : "فاندد"
            : null}{" "}
          | {account && account.challenge_name}
        </span>

        <div className="flex flex-col gap-1.5">
          <p className="text-xs font-thin text-zi-text-dark/70">
            نوع حساب:
            <span className="font-normal text-zi-text-dark">
              {account
                ? account.challenge_type === "real"
                  ? "حساب چالش"
                  : "حساب تمرینی"
                : null}
            </span>
          </p>

          <p className="text-xs font-thin text-zi-text-dark/70">
            کد حساب:
            <span className="font-normal text-zi-text-dark">
              {account && account.code}
            </span>
          </p>
        </div>
      </div>

      <div className="w-full flex justify-between items-end">
        <div className="flex flex-col gap-1.5">
          <span className="text-xs font-thin text-zi-text-dark/70">
            {color === "blue" && "تاریخ پایان"}
            {color === "yellow" && "تاریخ غیر فعال شدن"}
            {color === "green" && "تاریخ تکمیل"}
            {color === "red" && "تاریخ رد شدن"}
          </span>

          <p className="text-sm font-normal text-zi-text-dark">
            {account?.phase_type !== "funded"
              ? accountType === "live"
                ? isoToJalali(account.phase_ends_at)
                : isoToJalali(account.updated_at)
              : "بدون محدودیت"}
          </p>
        </div>

        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-dark/70">
            {(color === "blue" || color === "yellow") && "بالانس فعلی"}
            {(color === "green" || color === "red") && "بالانس نهایی"}
          </span>

          <p className="text-2xl font-medium text-zi-text-dark">
            ${account && Number(account.current_balance).toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
}
